import { Component, EventEmitter, OnInit, Output, ViewChild, ElementRef, Input, SimpleChanges, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Account } from 'src/app/screens/user-profile/client-data';
import { TranslateService } from '@ngx-translate/core';
import { AccountType } from 'src/app/models/mutualFund';
import { CompanyList } from 'src/app/models/company-list';
import { SharedService } from 'src/app/services/shared.service';
import { FavService } from 'src/app/services/fav.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search-symbols-modal',
  templateUrl: './search-symbols-modal.component.html',
  styleUrls: ['./search-symbols-modal.component.scss']
})
export class SearchSymbolsModalComponent implements OnInit {
  @Output() userChanged = new EventEmitter<Account>();
  @Output() companyChanged = new EventEmitter<CompanyList>();
  @Input() inputUser: Account;
  @Input() isBindValue: boolean;
  @Input() isFund:boolean;
  @Input() isCompanySearch:boolean;
  clientList: Account[] = [];
  isFavClients: boolean = false;
  selectedClient;
  tempClient: Account;
  savedRelCode;
  favClients: Account[] = [];
  searchValue: string = '';
  @ViewChild('searchInput', { static: false }) inputEl: ElementRef;
  subscription: any;
  FUND: number = AccountType.FUND;
  BASIC: number = AccountType.BASIC;
  MINOR: number = AccountType.MINOR;
  toggleBool: boolean;
  companies: CompanyList[];
  records: any = [];
  favCompanies: CompanyList[];
  lang: string;


  constructor(
    public dialogRef: MatDialogRef<SearchSymbolsModalComponent>,
    public translate: TranslateService,
    private sharedService: SharedService,
    private favService: FavService,
    private nav: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.isCompanySearch = data.isCompanySearch || false;
  }

  ngOnInit(): void {
    this.lang = this.translate.currentLang
    if (this.isCompanySearch) {
    this.companies = this.sharedService.allMarketCompanies;
      this.favService.favCompanies.subscribe((res) => {
        this.favCompanies = res;
      });
    }
    if (this.inputUser) {
      this.clientList = [this.inputUser];
      this.selectedClient = this.inputUser.relationCode;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.inputUser &&
      changes.inputUser.previousValue &&
      this.selectedClient !== changes.inputUser.currentValue?.relationCode
    ) {
      this.selectedClient = changes.inputUser.currentValue?.relationCode;
      this.tempClient = changes.inputUser.currentValue;
      this.userChange(changes.inputUser.currentValue);
    }
  }

  setFocus() {
    setTimeout(() => this.inputEl.nativeElement.focus());
  }


  userChange(client: Account) {
    if (client?.clientNameEn && this.savedRelCode !== client.relationCode) {
      this.selectedClient = client.relationCode;
      this.savedRelCode = client.relationCode;
      this.userChanged.emit(client);
      this.clientList = [];
    }
  }
  onCompanySelect(company: CompanyList): void {
    this.symbolChange(company); 
    this.dialogRef.close(company); 
  }
  symbolChange(company: CompanyList) {
    if (company?.SYMBOL_CODE) {
      this.companyChanged.emit(company);
    }
  }


  
  customSearchFn(term: string, item: Account): boolean {
    if (!term) return true;
      term = term.toLowerCase();
      return (
      (item.clientNameAr && item.clientNameAr.toLowerCase().includes(term)) || // Check Arabic name
      (item.clientNameEn && item.clientNameEn.toLowerCase().includes(term)) || // Check English name
      (item.relationCode && item.relationCode.toLowerCase().includes(term))   // Check relation code
    );
  }
  

  isFavClient(relCode: string): boolean {
    return !!this.favClients.find((client) => client.relationCode === relCode);
  }


  closeModal() {
    this.dialogRef.close();
  }

  credentialsSearchFilter(event: any) {
    const val = event.target.value.toLowerCase();

    if (val != "") {
      this.toggleBool = true;
    } else {
      this.toggleBool = false;
    }

    this.records = this.companies.filter(function (d) {
      return (
        d.ENG_NAME?.toLowerCase().includes(val) ||
        d.ARB_NAME?.toLowerCase().includes(val) ||
        d.Reuters?.toLowerCase().includes(val)
      );
    });
  }
  ngAfterViewInit() {
    this.sharedService.isDataLoaded.subscribe((res) => {
      if (res) this.companies = this.sharedService.allMarketCompanies;

      // this.orderBuy(this.companies[0], false);
    });
    this.favService.favCompanies.subscribe((res) => {
      this.favCompanies = res;
    });
  }
  navigateProfile(item) {
    this.searchValue = "";
    this.nav
      .navigate(["/company-profile", item.SYMBOL_CODE, item.Reuters])
      .then(() => (this.toggleBool = false));
  }
  isFav(symbol) {
    return this.favService.isFav(symbol);
  }

}
